<template>
  <div class="content">
    <PeriodicalContent v-if="periodical == 1  || periodical == 4"/>
    <!-- <SchoolContent v-else-if="periodical == 5" /> -->
    <DailyContent v-else />
  </div>
</template>

<script>
import PeriodicalContent from './PeriodicalContent'
// import SchoolContent from './SchoolContent'
import DailyContent from './DailyContent'
import { computed } from 'vue'
import { useStore } from 'vuex'
export default {
  name: 'Content',
  components: { PeriodicalContent, DailyContent },
  setup () {
    const store = useStore()
    const periodical = computed(() => store.state.periodical)
    return {
      periodical
    }
  }
}
</script>
<style lang="scss" scoped>
// .content{
//   -webkit-user-select: text;
// }
</style>
